import React from 'react';

import DynamicTable from '../../../../core/web/js/table/DynamicTable';
import {updateSort, updateColumnViewOrder, updateFilter, updateSelectionString} from '../../../../core/web/js/table/TableUtil';


function ListTable(props){
  return (
      <DynamicTable
        caption={props.caption||null}
        columns={props.columns}
        rows={props.rows}
        render={props.render}

        selection={props.state.selection}
        updateSelection={updateSelectionString.bind(this, props, 'selection')}

        sort={props.state.sort}
        updateSort={updateSort.bind(this, props, 'sort')}

        filter={props.state.filter}
        updateFilter={updateFilter.bind(this, props, 'filter')}

        columnView={props.state.columnView}
        columnOrder={props.state.columnOrder}
        updateColumnView={updateColumnViewOrder.bind(this, props, 'columnView', 'columnOrder')}
      />
  );
}

export default ListTable;
